<template>
    <div>
        <div>Layers</div>
        <div>
            <button @click="onNewLayer()">New layer</button>
        </div>
        <div>
            <Layer v-for="layer in layers" :key="layer.name" :layer="layer" :project="project"></Layer>
        </div>
    </div>
</template>

<script>
    import Layer from "./Layer.vue";

    export default {
        name: "LayerList",

        components: {Layer},

        props: ['project'],

        data: function () {
            return {};
        },

        computed: {
            layers: function () {
                return this.project ? this.project.layers : [];
            }
        },

        methods: {
            onNewLayer: function () {
                this.project.createLayer();
            }
        }
    }
</script>

<style scoped>

</style>
